/* eslint-disable eqeqeq */
import Axios from "axios";
import { FEMALE_BENEFITS, useCotizador } from "../context/apiContext";
import { useFeeTable } from "./FeeTableHook";
import { useSteps } from "./useSteps";
import { useAuth } from "../context/userContext";
import { saveCotizadorData, sendCotizadorData } from "../api/ApplicationApi";
import { arrayIncludesNumber, equal } from "helpers/toolsHelper";
import { BENEFITS_NEGATIVES } from "helpers/benefitsNegatives";
import {
  getRegularBenefitAdapt,
  getStructuralBenefitAdapt,
} from "helpers/cotizador/adapterHelper";
import { useContext } from "react";
import { TextsContext } from "../context/textsContext";
import { transformData } from "components/utils/RequestQuoter.util";
import BenefitDictionary from "utils/BenefitDictionary";
import { addBeneficiaryNameInPayments } from "helpers/TransformPaymentDetails";

export const useCotizacionAdapter = () => {
  const {
    contextState,
    structuralData,
    regularData,
    selectedBenefitsIds,
    isFemale,
    //fee,
  } = useCotizador();
  const { getFullRider: getRider, getFullPremiumAnnual: getPremiumAnnual } =
    useFeeTable();
  const { getBenefitsPerStep } = useSteps();
  const { user } = useAuth();
  const { getCurrentLanguage } = useContext(TextsContext);


  const getDependants = () => {
    return contextState.dependants.map((dependant) => ({
      BirthDate: dependant.birthday,
      Country: dependant.country,
      Email: '',
      Gender: dependant.gender == 1 ? "m" : "f",
      LastName: dependant.surname,
      Name: dependant.name,
      Province: 0,
      Relationship: dependant.componentId == 15 ? 1 : 2,
    }));
  };

  const getOwner = () => {
    return {
      BirthDate: contextState.birthday,
      Country: contextState.country,
      Email: contextState.email,
      Gender: contextState.gender == 1 ? "m" : "f",
      LastName: contextState.surname,
      Name: contextState.name,
      Province: "0",
      Relationship: 0,
    };
  };

  const getStructuralBenefits = () => {
    return structuralData
      .map((benefit) => {
        if (getBenefitsPerStep().includes(benefit["factorId.id"])) {
          if (
            arrayIncludesNumber(Object.values(selectedBenefitsIds), benefit.id)
          )
            return getStructuralBenefitAdapt(contextState, benefit);
        } else {
          if (
            arrayIncludesNumber(
              BENEFITS_NEGATIVES.map((i) => i.id),
              benefit.id
            )
          ) {
            return getStructuralBenefitAdapt(contextState, benefit);
          }
        }

        return false;
      })
      .filter((i) => !!i);
  };

  const getRiderByBenefitCode = (riders, code) => {
    if (!Array.isArray(riders) || !code) {
      throw new Error("Riders no válidos");
    }

    const rider = riders.find(item => item.IdBenefit === code);
    return rider;
  }

  const getRiders = () => {
    let { riders } = transformData(contextState)

    const benefitDictionary = new BenefitDictionary()

    const listRegularBenefits = getRegularBenefits()
    const listMaternityBenefits = getMaternityBenefits()
    const allBenefitsRegular = [...listRegularBenefits, ...listMaternityBenefits]

    riders = riders.map((rider) => {
      const oldRider = getRiderByBenefitCode(allBenefitsRegular, rider.benefitCode)
      return {
        BeginDate: contextState.coverage,
        EndDate: "",
        IdRider: rider.benefitCode,
        PortalType: benefitDictionary.getBenefitValue(rider.benefitCode),
        OptionCode: benefitDictionary.getOptionValue(rider.benefitCode, rider.optionCode),
        Status: "A",
        DescriptionOption: oldRider?.DescriptionOption,
        NoCoverage: oldRider?.NoCoverage,
        Description: oldRider?.Description,
        Type: rider.benefitCode === 'matrnity' ? 'M' : 'P'
      }
    })

    return riders
  }

  const getRegularBenefitsWithoutRider = () => {

    const listRiders = new Set(["healthch", "matrnity", "eyesurgr", "barsurgr"])
    const listRegularBenefits = getRegularBenefits()
    const listOrganTransplant = getOrganTransplant()
    let regularsBenefit = [...listRegularBenefits, ...listOrganTransplant]
    return regularsBenefit.filter((benefit) => !listRiders.has(benefit.IdBenefit))

  }

  const getRegularBenefits = () => {
    return regularData
      .map((benefit) => {
        if (FEMALE_BENEFITS.includes(benefit["factorId.id"])) {
          return false;
        }
        if (getBenefitsPerStep().includes(benefit["factorId.id"])) {
          if (
            arrayIncludesNumber(Object.values(selectedBenefitsIds), benefit.id)
          )
            return getRegularBenefitAdapt(contextState, benefit);
        } else {
          if (
            arrayIncludesNumber(
              BENEFITS_NEGATIVES.map((i) => i.id),
              benefit.id
            )
          ) {
            return getRegularBenefitAdapt(contextState, benefit);
          }
        }

        return false;
      })
      .filter((i) => !!i);
  };

  const getMaternityBenefits = () => {
    const mapMaternityBenefits = (benefit) => {
      const isMaternityBenefitAndIsApproved =
        arrayIncludesNumber(Object.values(selectedBenefitsIds), benefit.id) &&
        FEMALE_BENEFITS.includes(benefit["factorId.id"]) &&
        isFemale() && contextState.outpationBenefitsmaternidad

      const isMaternityDefaultAndNotApproved = FEMALE_BENEFITS.includes(benefit["factorId.id"]) && (!isFemale() || !contextState.outpationBenefitsmaternidad) && arrayIncludesNumber(
        BENEFITS_NEGATIVES.map((i) => i.id),
        benefit.id
      )

      if (isMaternityBenefitAndIsApproved)
        return getRegularBenefitAdapt(contextState, benefit);
      else if (isMaternityDefaultAndNotApproved)
        return getRegularBenefitAdapt(contextState, benefit);

      return false;
    };

    return regularData
      .map(mapMaternityBenefits)
      .filter((i) => !!i);
  };

  const getOrganTransplant = () => {
    return [
      {
        BeginDate: contextState.coverage,
        EndDate: "",
        Description: "Organ and tissue transplant",
        PortalType: "org_transplant",
        CodeFactor: "org_transplant",
        CodeOption: "org_transplant",
        DescriptionOption: contextState.organRiderName,
        IdOption: contextState.organId?.toString?.(), //no existe todavia
        Factor: contextState.organRider,
        IdBenefit: "org_transplant",
        NoCoverage: "0",
        Status: "A"
      },
    ];
  };

  const getPaymentInformation = () => {
    const throwIfNoQuotation = () => {
      throw new Error('No hay cotización')
    }

    try {
      const { calculation } = contextState || {}
      const { data } = calculation || {}
      const { quotation } = data || {}
      const { fee, totalPremium } = quotation || {}

      if (!fee || !totalPremium) throwIfNoQuotation();

      return {
        BillMode: {
          annual: 1,
          semiannual: 2,
          quarterly: 3,
          monthly: 4,
        }[contextState.timely],
        PremiumAmount: totalPremium,
        Fee: fee,
      }

    } catch (e) {
      throwIfNoQuotation()
    }
  }

  const getPayments = () => {
    const throwIfNoQuotation = () => {
      throw new Error('No hay cotización')
    }

    try {
      const { calculation } = contextState || {}
      const { data } = calculation || {}
      const { quotation } = data || {}
      const { payments, members } = quotation || {}

      if (!payments || !members) throwIfNoQuotation();

      return addBeneficiaryNameInPayments(payments, members)

    } catch (e) {
      throwIfNoQuotation()
    }
  }


  const getData = async (extra = {}) => {
    const {
      data: { ip },
    } = await Axios("https://api.ipify.org?format=json", { method: "GET" });
    const Source = localStorage.getItem("source");

    const { apQuoteId } = user;

    let OriginalApQuoteId = null

    if (apQuoteId) {
      OriginalApQuoteId = apQuoteId
    }

    const attributes = {
      AgentId: user.agentId.toString(),
      UserId: user.userId.toString(),
      OriginalApQuoteId,
      EffectiveDate: contextState.coverage,
      OptionId: 2607,
      Owner: getOwner(),
      Dependents: getDependants(),
      StructuralBenefits: getStructuralBenefits(),
      RegularBenefits: getRegularBenefitsWithoutRider(),
      Riders: getRiders(),
      PaymentInformation: getPaymentInformation(),
      Payments: getPayments(),
      Plan: "my_vip_care",
      TypeApplication: 1,
      IpAddress: ip,
      Lang: getCurrentLanguage(),
      Source,
      ...extra
    };

    if (user?.agentNumber && !equal(user?.agentNumber, 1)) {
      attributes['AgentNumber'] = user.agentNumber.toString();
    }

    return attributes;
  };

  const createApplication = async (last_inserted_quotation_id = 0) => {

    const { isCountryResidenceDeductible } = contextState

    const { data } = await sendCotizadorData(await getData({ QuoteId: last_inserted_quotation_id, IsCountryResidenceDeductible: Boolean(isCountryResidenceDeductible) }));
    return data;
  };

  return {
    getData,
    createApplication,
  };
};
